export default "__VITE_ASSET__I3QX8nX1__"